<template>
  <div>
    <v-btn small text @click="handleClick" class="menu-item-btn">
      <v-icon size="18" class="mr-2">mdi-content-duplicate</v-icon>
      <span>Duplicar colaboração</span>
    </v-btn>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { v4 as uuidv4 } from "uuid";
import { mapActions } from "vuex";

export default {
  props: {
    item: Object,
    getColaboracoesAprovadas: Function,
    page: Number,
    flg_exibida: Boolean,
    flg_favorita: Boolean,
    cod_pasta: Number
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      setCopyColaboracoesRecebidas: "colaboracoes_aprovadas/setCopyColaboracoesRecebidas",
    }),
    async handleClick() {
      const id_colaboracao = this.item.id_colaboracao.split("_").at(0) + "_" + uuidv4();
      const formData = {
        id_colaboracao,
        cod_producao: this.item.cod_producao,
        dsc_fonte_colaboracao: this.item.dsc_fonte_colaboracao,
        dsc_nome_colaborador: this.item.dsc_nome_colaborador,
        flg_colaborador_verificado: this.item.flg_colaborador_verificado,
        dsc_colaborador_user: this.item.dsc_colaborador_user,
        dsc_texto_colaboracao: this.item.dsc_texto_colaboracao,
        url_avatar_colaborador: this.item.url_avatar_colaborador,
        flg_sem_avatar: this.item.flg_sem_avatar,
        dsc_arquivo_gcp: this.item.dsc_arquivo_gcp,
        dsc_colaborador_phone: this.item.dsc_colaborador_phone,
        dsc_colaborador_email: this.item.dsc_colaborador_email,
        dat_colaboracao: this.item.dat_colaboracao,
      };
      await apiClient
        .post("/inserirColaboracao", formData)
        .then(async () => {
          if (this.item.midias.length > 0) {
            for (const media of this.item.midias) {
              await apiClient.post("/inserirImagemColaboracao", {
                id_colaboracao,
                cod_producao: this.item.cod_producao,
                id_imagem: media.id_imagem,
                dsc_tipo_midia_colaboracao: media.dsc_tipo_midia_colaboracao,
                url_midia_colaboracao: media.url_midia_colaboracao,
                url_midia_thumbnail: media.url_midia_thumbnail,
                flg_selecionada: media.flg_selecionada,
                dsc_extencao_midia: media.dsc_extencao_midia,
              });
            }
          }
          if(this.flg_favorita) {
            await apiClient
            .patch(`/favoritarColaboracao/${id_colaboracao}`, {
              flg_favorita: this.item.flg_favorita,
              cod_producao: this.item.cod_producao
            })
          }
          await this.getColaboracoesAprovadas({
            page: this.page,
            size: 5,
            cod_producao: this.item.cod_producao,
            flg_favorita: this.flg_favorita,
            flg_exibida: this.flg_exibida,
            cod_pasta: this.cod_pasta
          })
          this.setCopyColaboracoesRecebidas(
            this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas
          );
          this.$toast.success("Colaboração copiada com sucesso!");
        })
        .catch((error) => {
          console.err(error);
          this.$toast.error("Erro ao tentar copiar colaboração");
        });
    },
  },
};
</script>
